<script lang="ts" setup generic="T extends string | number">
import type { VSelect } from 'vuetify/components'

export interface SelectItem<T extends string | number = string | number> {
  value: T
  title: string
  divider?: boolean
}

const { variant = 'filled', dataCy = 'value_select_multiple' } = defineProps<{
  items: SelectItem<T>[]
  label?: string
  disabled?: boolean
  dataCy?: string
  variant?: VSelect['$props']['variant']
  density?: VSelect['$props']['density']
  width?: VSelect['$props']['width']
}>()

const selectedValue = defineModel<T>({ required: true })
</script>

<template>
  <div v-if="items.length > 1">
    <v-select
      v-model="selectedValue"
      menu-icon="custom:arrow_down"
      :items="items"
      :variant="variant"
      :density="density"
      :label="label"
      :width="width"
      :hide-details="true"
      :disabled="disabled"
      :data-cy="dataCy"
    />
  </div>
</template>
